// import 'bootstrap/scss/bootstrap.scss';
// import 'bootstrap/scss/_mixins.scss';
import '@fortawesome/fontawesome-free/js/all';
// import 'material-icons/iconfont/material-icons.css';

// import 'custom-select/src/css/custom-select.css';

$('.modal').appendTo('body');

// Slick Slider
// import 'slick-carousel/slick/slick.scss';
// import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.min';

// JS
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';

// Custom JS
import './base';
import './video-portal-page';
import './video-playlist';
import './card-scroller';
import './feature-block';
import './image-compare';
import './datepicker';
import './int-timeline';
import './image-video';
import './alert';
import './maps-callout';
import './shopify-products';
import './research-tools';
import './media-gallery';
import './jump-list';
import './tabs';
import './special-exhibit';
import './contests';
import './social-media-feed';
import './scroll-to-top';
